// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.partnership_main_container{
    height: 722px;
    background: linear-gradient(to bottom, #EAAD11 0%, #D40E1F 150%);
    position: relative;
    padding: 0 50px;
    color: #ffffff;
}

.partnershipbgImg_container{
    position: absolute;
    top: 0;
    right: 0;
}

.partnership_gallery_container{
    display: flex;
    padding-top: 200px;
    gap: 20px;
}

.partnership_gallery_column2{
    display: flex;
    gap: 20px;
    justify-content: center;
    align-items: center;
}

.partnership_gallery_part1{
    text-align: center;
}

.partnership_gallery_part1_text1{
    font-weight: 400;
    font-size: 18px;
    list-style: 27.52px;
    color: #0F0F0F;
   
}

.partnership_gallery_part1h4{
    font-weight: 700;
    font-size: 36px;
    line-height: 55px;
    
}

.partnership_gallery_part1_text2{
    font-weight: 400;
    font-size: 18px;
    list-style: 27.52px;
}


@media screen and (max-width: 1050px){

    .partnership_main_container{
        height: 600px;
    }

    .partnership_gallery_column1 img{
        width:400px ;
    }

    .partnership_gallery_part2 img{
        height: 260px;
    }

    .partnership_gallery_part1_text1{
        font-size: 16px;
       
    }
    
    .partnership_gallery_part1h4{
        font-size: 30px;
        
    }
    
    .partnership_gallery_part1_text2{
        font-size: 16px;

    }
}


@media screen and (max-width: 900px){
    .partnership_main_container{
        height: 500px;
    }

    .partnership_gallery_column1 img{
        width:270px ;
    }

    .partnership_gallery_part2 img{
        height: 180px;
    }

    .partnership_gallery_part1_text1{
        font-size: 14px;
       
    }
    
    .partnership_gallery_part1h4{
        font-size: 24px;
        
    }
    
    .partnership_gallery_part1_text2{
        font-size: 12px;

    }

    .partnership_gallery_container{
        gap: 15px;
    }
    
    .partnership_gallery_column2{
        gap: 15px;
    }
}


@media screen and (max-width: 500px){
    .partnership_main_container{
        height: 1100px;
        padding: 0 20px;
    }
    
    .partnershipbgImg_container{
        position: absolute;
        top: 0;
        right: 0;
    }
    
    .partnership_gallery_container{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-top: 160px;
        gap: 30px;
    }
    
    .partnership_gallery_column2{
        display: flex;
        flex-direction: column;
        gap: 30px;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    
    .partnership_gallery_part1{
        text-align: center;
    }
    
    .partnership_gallery_part1_text1{
        font-weight: 400;
        font-size: 14px;
        list-style: 21.41px;
        color: #0F0F0F;
       
    }
    
    .partnership_gallery_part1h4{
        font-weight: 700;
        font-size: 24px;
        line-height: 55px;
        
    }
    
    .partnership_gallery_part1_text2{
        font-weight: 400;
        font-size: 14px;
        list-style: 21.41px;
        width: 339px;
    }

    .partnership_gallery_column1 img{
        width:100% ;
    }

    .partnership_gallery_part2{
        width: 100%;
    }

    .partnership_gallery_part2 img{
        height: 100%;
        width: 100%;
    }

    .integritybgImg_comtainer img{
        width: 100%;
    }
}


@media screen and (max-width: 380px){
    .partnership_main_container{
        height: 1000px;
        padding: 0 20px;
    }
    
    .partnership_gallery_part1_text1{
        font-weight: 400;
        font-size: 13px;
        list-style: 21.41px;
        color: #0F0F0F;
       
    }
    
    .partnership_gallery_part1h4{
        font-weight: 700;
        font-size: 22px;
        line-height: 55px;
        
    }
    
    .partnership_gallery_part1_text2{
        font-weight: 400;
        font-size: 13px;
        list-style: 21.41px;
    }

    .partnership_gallery_column1 img{
        width:100% ;
    }

    .partnership_gallery_part2 img{
        height: 100%;
    }
}


@media screen and (max-width: 330px){

    .partnership_main_container{
        height: 920px;

    }
    
    .partnership_gallery_part1_text1{
        font-weight: 400;
        font-size: 13px;
        list-style: 21.41px;
        color: #0F0F0F;
       
    }
    
    .partnership_gallery_part1h4{
        font-weight: 700;
        font-size: 21px;
        line-height: 55px;
        
    }
    
    .partnership_gallery_part1_text2{
        font-weight: 400;
        font-size: 12px;
        list-style: 21.41px;
        width: 260px;
    }

    .partnership_gallery_column1 img{
        width:100% ;
    }

    .partnership_gallery_part2 img{
        height: 300px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Partnership.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gEAAgE;IAChE,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;;;AAGA;;IAEI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;AACJ;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,eAAe;;IAEnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,SAAS;IACb;AACJ;;;AAGA;IACI;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,MAAM;QACN,QAAQ;IACZ;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,uBAAuB;QACvB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,cAAc;;IAElB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;;IAErB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;;AAGA;IACI;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,cAAc;;IAElB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;;IAErB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;AACJ;;;AAGA;;IAEI;QACI,aAAa;;IAEjB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,cAAc;;IAElB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;;IAErB;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".partnership_main_container{\n    height: 722px;\n    background: linear-gradient(to bottom, #EAAD11 0%, #D40E1F 150%);\n    position: relative;\n    padding: 0 50px;\n    color: #ffffff;\n}\n\n.partnershipbgImg_container{\n    position: absolute;\n    top: 0;\n    right: 0;\n}\n\n.partnership_gallery_container{\n    display: flex;\n    padding-top: 200px;\n    gap: 20px;\n}\n\n.partnership_gallery_column2{\n    display: flex;\n    gap: 20px;\n    justify-content: center;\n    align-items: center;\n}\n\n.partnership_gallery_part1{\n    text-align: center;\n}\n\n.partnership_gallery_part1_text1{\n    font-weight: 400;\n    font-size: 18px;\n    list-style: 27.52px;\n    color: #0F0F0F;\n   \n}\n\n.partnership_gallery_part1h4{\n    font-weight: 700;\n    font-size: 36px;\n    line-height: 55px;\n    \n}\n\n.partnership_gallery_part1_text2{\n    font-weight: 400;\n    font-size: 18px;\n    list-style: 27.52px;\n}\n\n\n@media screen and (max-width: 1050px){\n\n    .partnership_main_container{\n        height: 600px;\n    }\n\n    .partnership_gallery_column1 img{\n        width:400px ;\n    }\n\n    .partnership_gallery_part2 img{\n        height: 260px;\n    }\n\n    .partnership_gallery_part1_text1{\n        font-size: 16px;\n       \n    }\n    \n    .partnership_gallery_part1h4{\n        font-size: 30px;\n        \n    }\n    \n    .partnership_gallery_part1_text2{\n        font-size: 16px;\n\n    }\n}\n\n\n@media screen and (max-width: 900px){\n    .partnership_main_container{\n        height: 500px;\n    }\n\n    .partnership_gallery_column1 img{\n        width:270px ;\n    }\n\n    .partnership_gallery_part2 img{\n        height: 180px;\n    }\n\n    .partnership_gallery_part1_text1{\n        font-size: 14px;\n       \n    }\n    \n    .partnership_gallery_part1h4{\n        font-size: 24px;\n        \n    }\n    \n    .partnership_gallery_part1_text2{\n        font-size: 12px;\n\n    }\n\n    .partnership_gallery_container{\n        gap: 15px;\n    }\n    \n    .partnership_gallery_column2{\n        gap: 15px;\n    }\n}\n\n\n@media screen and (max-width: 500px){\n    .partnership_main_container{\n        height: 1100px;\n        padding: 0 20px;\n    }\n    \n    .partnershipbgImg_container{\n        position: absolute;\n        top: 0;\n        right: 0;\n    }\n    \n    .partnership_gallery_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        padding-top: 160px;\n        gap: 30px;\n    }\n    \n    .partnership_gallery_column2{\n        display: flex;\n        flex-direction: column;\n        gap: 30px;\n        justify-content: center;\n        align-items: center;\n        width: 100%;\n    }\n    \n    .partnership_gallery_part1{\n        text-align: center;\n    }\n    \n    .partnership_gallery_part1_text1{\n        font-weight: 400;\n        font-size: 14px;\n        list-style: 21.41px;\n        color: #0F0F0F;\n       \n    }\n    \n    .partnership_gallery_part1h4{\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 55px;\n        \n    }\n    \n    .partnership_gallery_part1_text2{\n        font-weight: 400;\n        font-size: 14px;\n        list-style: 21.41px;\n        width: 339px;\n    }\n\n    .partnership_gallery_column1 img{\n        width:100% ;\n    }\n\n    .partnership_gallery_part2{\n        width: 100%;\n    }\n\n    .partnership_gallery_part2 img{\n        height: 100%;\n        width: 100%;\n    }\n\n    .integritybgImg_comtainer img{\n        width: 100%;\n    }\n}\n\n\n@media screen and (max-width: 380px){\n    .partnership_main_container{\n        height: 1000px;\n        padding: 0 20px;\n    }\n    \n    .partnership_gallery_part1_text1{\n        font-weight: 400;\n        font-size: 13px;\n        list-style: 21.41px;\n        color: #0F0F0F;\n       \n    }\n    \n    .partnership_gallery_part1h4{\n        font-weight: 700;\n        font-size: 22px;\n        line-height: 55px;\n        \n    }\n    \n    .partnership_gallery_part1_text2{\n        font-weight: 400;\n        font-size: 13px;\n        list-style: 21.41px;\n    }\n\n    .partnership_gallery_column1 img{\n        width:100% ;\n    }\n\n    .partnership_gallery_part2 img{\n        height: 100%;\n    }\n}\n\n\n@media screen and (max-width: 330px){\n\n    .partnership_main_container{\n        height: 920px;\n\n    }\n    \n    .partnership_gallery_part1_text1{\n        font-weight: 400;\n        font-size: 13px;\n        list-style: 21.41px;\n        color: #0F0F0F;\n       \n    }\n    \n    .partnership_gallery_part1h4{\n        font-weight: 700;\n        font-size: 21px;\n        line-height: 55px;\n        \n    }\n    \n    .partnership_gallery_part1_text2{\n        font-weight: 400;\n        font-size: 12px;\n        list-style: 21.41px;\n        width: 260px;\n    }\n\n    .partnership_gallery_column1 img{\n        width:100% ;\n    }\n\n    .partnership_gallery_part2 img{\n        height: 300px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
